module.exports = __webpack_public_path__ + "img/icons_26.c6a9c273.png";